import { render, staticRenderFns } from "./Producer.vue?vue&type=template&id=350ab650"
import script from "./Producer.vue?vue&type=script&lang=js"
export * from "./Producer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports